// extracted by mini-css-extract-plugin
export default {"nav":"home_nav__M5z9r"};